import { flow } from 'mobx-state-tree';

// Types
import { Kiosk } from '@common/models/kiosks/types';

import http from '@clientCommon/app/bootstrap/http';

import { API_BASE } from '@clientCommon/app/constants';
import { MODEL_ROUTE } from '../../constants';

/**
 *
 */
export default flow(function* (kioskId: string) {
  const response: Kiosk = yield http.get({
    url: `${API_BASE}${MODEL_ROUTE}/${kioskId}`,
  });

  return response;
});
